/**
 * Place to store vc pinboard mutable state.
 * The `state` property within the store class contains the
 * actual data that changes.
 *
 * @see https://vuejs.org/v2/guide/state-management.html#Simple-State-Management-from-Scratch
 */
import { reactive } from 'vue'

/**
 * Interface for the state property inside the store
 */
export interface IVcPinboardStoreState {
  skus?: string[]
  tags?: string[]
  brands?: string[]
}

/**
 * The store class itself. An instance is created below and exported as
 * the default export.
 */
export class Store {
  state: IVcPinboardStoreState = reactive({
    skus: [],
    tags: [],
    brands: []
  })

  set skus(skus: string[]) {
    this.state.skus = skus
  }

  get skus(): string[] {
    return this.state.skus
  }

  set tags(tags: string[]) {
    this.state.tags = tags
  }

  get tags(): string[] {
    return this.state.tags
  }

  set brands(brands: string[]) {
    this.state.brands = brands
  }

  get brands(): string[] {
    return this.state.brands
  }
}

export default new Store()

